<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons"></div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Histórico de Alterações</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getLogs()">
            <div class="table-filters">
              <app-input
                label="Descrição"
                placeholder="Pesquisar"
                name="TX_LOGS"
                formControlName="TX_LOGS"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data de Início"
                placeholder="Digite aqui"
                name="DT_INIC_LOGS"
                formControlName="DT_INIC_LOGS"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data de Término"
                placeholder="Digite aqui"
                name="DT_TERM_LOGS"
                formControlName="DT_TERM_LOGS"
                width="100%"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form class="table-filters" [formGroup]="form" (ngModelChange)="getLogs()">
      <app-input
        label="Descrição"
        placeholder="Pesquisar"
        name="TX_LOGS"
        formControlName="TX_LOGS"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data de Início"
        placeholder="Digite aqui"
        name="DT_INIC_LOGS"
        formControlName="DT_INIC_LOGS"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data de Término"
        placeholder="Digite aqui"
        name="DT_TERM_LOGS"
        formControlName="DT_TERM_LOGS"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
